import React, { useState } from 'react';
import {
  Modal,
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
  Fade
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FiterAPI from '../fiterAPI';

const secondDropdownValues = {
  Sim: [
    'Problemas financeiros',
    'Problemas psicológicos',
    'Problemas familiares',
    'Dificuldades acadêmicas',
    'Insatisfação com os sistemas da faculdade',
    'Insatisfação com a infraestrutura da faculdade',
    'Aluno não reportou problema',
    'Outros'
  ],
  Não: [
    'Aluno não teve disponibilidade',
    'Aluno cancelou a matrícula',
    'Aluno sem devolutiva',
    'Aluno se negou a participar'
  ],
  '': []
};

const actions = {
  'Problemas financeiros': 'Suporte/Atendimento Financeiro - SAA/CRA',
  'Problemas psicológicos': 'Equipe de Acolhimento Psicológico',
  'Problemas familiares': 'Núcleo de Práticas Sociais',
  'Dificuldades acadêmicas': 'Equipe de Acolhimento Psicopedagógico',
  'Insatisfação com os sistemas da faculdade': 'Suporte Técnico',
  'Insatisfação com a infraestrutura da faculdade':
    'Equipe da Administração; Manutenção e Apoio',
  'Aluno não teve disponibilidade': 'Agendar uma nova data',
  'Aluno cancelou a matrícula': 'Entrar em contato para saber o motivo',
  'Aluno sem devolutiva': 'Entrar em contato novamente',
  'Aluno se negou a participar': 'Reforçar a importância da participaçāo'
};

function Obs(props) {
  const {
    icon,
    color,
    comments,
    pulseId,
    currentUserId,
    usersList = [],
    authorId,
    secondDropdownValueProps,
    firstDropdownValueProps,
    actionProps,
    currentInstitution
  } = props;
  const [show, setShow] = useState(false);
  const [obs, setObs] = useState(comments);
  const [userName, setUserName] = useState('');
  const [firstDropdownValue, setFirstDropdownValue] = useState(
    firstDropdownValueProps
  );
  const [secondDropdownValue, setSecondDropdownValue] = useState(
    secondDropdownValueProps
  );
  const [action, setAction] = useState(actionProps);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleTextChange = event => {
    const { value } = event.target;
    setObs(value);
  };

  const handleFirstDropdownChange = e => {
    const { value } = e.target || {};
    setFirstDropdownValue(value);
    setSecondDropdownValue('');
  };
  const handleSecondDropdownChange = e => {
    const { value } = e.target || {};
    setSecondDropdownValue(value);
    setAction(actions[value]);
  };

  const onSaveChanges = async () => {
    console.log({
      obs,
      pulseId,
      currentUserId,
      firstDropdownValue,
      secondDropdownValue,
      action
    });
    await FiterAPI.updatePulseObs({
      obs,
      pulseId,
      currentUserId,
      firstDropdownValue,
      secondDropdownValue,
      action
    });
    const [userName] = usersList.filter(user => user.id === currentUserId);
    setUserName(userName?.name);
    setShow(false);
  };

  // try {
  //   const [userName] = usersList.filter(user => user.id == authorId.id);
  //   setUserName(userName?.name);
  // } catch (err) {
  //   console.error(err)
  // }

  return (
    <>
      {(obs || firstDropdownValue) ? (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip style={{ display: obs ? "inherit" : "none" }}>{obs}</Tooltip>}
          popperConfig={{
            modifiers: {
              preventOverflow: {
                enabled: false
              }
            }
          }}
        >
          <span>
            <FontAwesomeIcon
              icon={icon}
              onClick={handleShow}
              className="ml-1 mr-1"
              style={{ cursor: 'pointer' }}
            />
          </span>
        </OverlayTrigger>
      ) : (
        <span>
          <FontAwesomeIcon
            icon={icon}
            color={color}
            onClick={handleShow}
            className="ml-1 mr-1"
            style={{ cursor: 'pointer' }}
          />
        </span>
      )}{' '}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Anotações</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {
              ((currentInstitution && currentInstitution.name === "Unime") || process.env.REACT_APP_FITER_ENV === 'development')
                ? <><Form.Group controlId="firstDropdown">
                  <Form.Label>Conversou com o aluno?</Form.Label>
                  <Form.Control as="select" onChange={handleFirstDropdownChange}>
                    <option value="">Escolher</option>
                    <option
                      value="Sim"
                      selected={firstDropdownValue === 'Sim'}
                      key="sim"
                    >
                      Sim
                    </option>
                    <option
                      value="Não"
                      selected={firstDropdownValue === 'Não'}
                      key="nao"
                    >
                      Não
                    </option>
                  </Form.Control>
                </Form.Group>
                  <Form.Group controlId="secondDropdown">
                    <Form.Label>O que o aluno reportou?</Form.Label>
                    <Form.Control
                      as="select"
                      disabled={!firstDropdownValue}
                      onChange={handleSecondDropdownChange}
                    >
                      <option value="">Escolher</option>
                      {secondDropdownValues[firstDropdownValue].map(value => (
                        <option
                          value={value}
                          selected={secondDropdownValue === value}
                          key={value}
                        >
                          {value}
                        </option>
                      ))}
                    </Form.Control>
                    <Fade in={actions[secondDropdownValue]} timeout={2000}>
                      <div
                        style={{
                          marginTop: '10px',
                          transition: 'opacity 1s linear'
                        }}
                        className={
                          actions[secondDropdownValue] ? 'alert alert-primary' : ''
                        }
                        id="alert"
                      >
                        {actions[secondDropdownValue] && (
                          <>
                            <b>Ação: </b>
                            {actions[secondDropdownValue]}
                          </>
                        )}
                      </div>
                    </Fade>
                  </Form.Group>
                </>
                : <></>
            }
          </>

          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>Comentário</Form.Label>
            <Form.Control
              as="textarea"
              rows="3"
              value={obs || ''}
              onChange={handleTextChange}
              disabled={!secondDropdownValue || !((currentInstitution && currentInstitution.name === "Unime") || process.env.REACT_APP_FITER_ENV === 'development')}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
          <Button variant="primary" onClick={onSaveChanges}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Obs;
